// @ts-strict-ignore
import React, {
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useUniqueId } from '@usealloy/component-library';
import { AggregationEditorContext } from './context';
import { StyledAggregationTextField } from './styles';
import { parseAndClamp } from './helpers';

export interface AggregationNumberInputProps {
  minValue: number;
  maxValue: number;
  value: number;
  onHandleValueChange: (value: number) => void;
  /** Number of decimal places allowed. 0 = integer only (default). */
  decimalScale?: number;
  className?: string;
}

const AggregationNumberInput = ({
  minValue,
  maxValue,
  value,
  onHandleValueChange,
  decimalScale = 0,
  className,
}: AggregationNumberInputProps) => {
  const { keyboardFocus } = useContext(AggregationEditorContext);

  const ref = useRef<HTMLInputElement>(null);
  const id = useUniqueId('aggregation-number-input');

  useEffect(() => {
    keyboardFocus?.register({ id, ref });
    return () => keyboardFocus?.unregister(id);
  }, [id, keyboardFocus]);

  return (
    <span className={className} data-aggregation-number-input>
      <StyledAggregationTextField
        ref={ref}
        id={id}
        type="number"
        widthFitContent
        value={Number.isFinite(value) ? value : minValue}
        onChange={e => {
          onHandleValueChange(
            parseAndClamp({
              rawValue: e.target.value,
              clampValues: { min: minValue, max: maxValue },
              decimalScale,
            }),
          );
        }}
      />
    </span>
  );
};

export default AggregationNumberInput;
